/**
 * A landing page's content, from the CMS.
 */
import { createServerFn } from "@tanstack/react-start";

import { cmsRegistry } from "@/content/cmsRegistry";
import { contentSource } from "@/content/source";
import type { LandingPage } from "./types";

const resolve = cmsRegistry<LandingPage>({
  // Through `contentSource()`, whose dynamic import is what keeps the CMS
  // client out of the client chunk, measured at 74 kB shipped to browsers that
  // never call it.
  load: async () => (await contentSource()).loadLandingPages(),
  keyOf: (page) => page.path,
});

/**
 * A server function rather than a plain loader call: a route loader re-runs in
 * the browser on client-side navigation, where the CMS client is not shipped.
 */
export const landingPageContent = createServerFn({ method: "GET" })
  .inputValidator((path: unknown): string => String(path ?? ""))
  .handler(({ data }): Promise<LandingPage | undefined> => resolve(data));
